export default {"src":"https://images-cdn.curipod.com/d-9b8a1ff9/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};